module.exports = __webpack_public_path__ + "img/belgium-diabetes-mellitus-female.ea9c1784.png";